/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import HTMLViewer from '../../components/HTMLViewer';
import AnimatedButton from '../../components/Button';
import ApplicationContext from '../../context/ApplicationContext';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { dataService } from '../../services/data.service';
import moment from 'moment-timezone';
import { generateDeviceFingerprint, handleToast } from '../../helpers/CommonFunctions';
import Dropdown from '../../components/Dropdown';
import { appointmentLanguageContent } from './appointmentLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';
import BackButton from '../../components/Button/BackButton';

function RescheduleAppointment(props) {
    const { facilityData, currentAppointment, handlePage, selectedLanguage, selectedLanguageName } = useContext(ApplicationContext);
    const [selectedOption, setSelectedOption] = useState('');
    const [selectedTime, setSelectedTime] = useState('Morning');
    const [loading, setLoading] = useState(false);

    const handleStatusChange = (status) => {
        setLoading(true);
        const payload = {
            "patient_id": currentAppointment.patient_id,
            "fingerprint_id": generateDeviceFingerprint(),
            "new_schedule": `${selectedOption}, ${selectedTime}`,
            "appointment_date": moment(currentAppointment).format('Do MMMM'),
            "appointment_time": `${moment(currentAppointment.appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}`,
            "appointment_status": status
        }
        dataService.changeAppointmentStatus(sessionStorage.getItem('session'), payload).then((res) => {
            setLoading(false);
            if(res.error === false) {
                handlePage('identity');
            } else {
                handleToast(res.data.data.message);
            }
        })
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[5px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center'>
                    <AnimatedImage url="/images/Calendar.svg" alt="calendar" className="mr-[12px]" />
                    <p className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>{appointmentLanguageContent['appointment'][selectedLanguage]}</p>
                </p>
                <div className=''>
                    <p className={`font-normal text-sm text-[#333] ${selectedLanguage === 'ar' ? 'dir-rtl' : 'text-justify md:text-center lg:text-center xl:text-center'} justify-center break-words mt-[18px]`}>
                        {appointmentLanguageContent['reschedule-1'][selectedLanguage]}
                    </p>
                    <div className={`relative mt-[16px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                        <Dropdown dropdownID="appointment_dropdown" className="rounded-lg" 
                            options={['Sometime in the next week', 'Sometime in the next month', 'Soonest available']} selectedOption={selectedOption} setSelectedOption={setSelectedOption} placeholder={appointmentLanguageContent['choose-an-option'][selectedLanguage]} />
                    </div>
                    <div className=' mt-[39px] flex flex-col items-center'>
                        {appointmentLanguageContent['reschedule-2'][selectedLanguage]}
                        <div className='flex mt-2'>
                            <div onClick={() => setSelectedTime('Morning')} data-testid="morning_schedule"
                                className={`flex ${selectedTime === 'Morning' ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-l-[47px] border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                                <img src={selectedTime === 'Morning' ? '/images/sun-white.svg' : '/images/Sun.svg'} alt="morning" />
                                <p className={`font-normal ${selectedTime === 'Morning' ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{appointmentLanguageContent['mornings'][selectedLanguage]}</p>
                            </div>
                            <div onClick={() => setSelectedTime('Evening')} data-testid="evening_schedule" className={`flex ${selectedTime === 'Evening' ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-r-[47px] 
                            border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                                <img src={selectedTime === 'Evening' ? '/images/moon-white.svg' : '/images/Moon.svg'} alt="morning" />
                                <p className={`font-normal ${selectedTime === 'Evening' ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{appointmentLanguageContent['evenings'][selectedLanguage]}</p>
                            </div>
                        </div>
                    </div>
                    <div className='facility-profile mt-[55px] text-justify text-sm lg:text-center xl:text-center'>
                        <HTMLViewer htmlContent={facilityData.reschedule_message[selectedLanguageName]} />
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap gap-[12px]'>
                <BackButton disabled={loading} handleClick={() => handlePage('appointment_options')} backType="previous" />
                <AnimatedButton handleClick={() => handleStatusChange('Rescheduled')} 
                    disabled={selectedOption === '' || selectedTime === '' || loading} 
                    id="confirm_button" className={`font-semibold text-gray bg-[#F2F2F2] min-w-fit w-[200px] h-[40px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center fold-normal-text`}>
                    {!loading && <img src="/images/Calendar check.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em] mr-[10px]' />}
                    {loading ? <ThreeDotsBlackLoader /> : appointmentLanguageContent['confirm'][selectedLanguage]}
                    {!loading && <img src="/images/next.svg" alt="next" className='ml-[3] w-[1.7em] h-[1.7em]' />}
                </AnimatedButton>
            </div>
        </AnimatedPageFade>
    );
}

export default RescheduleAppointment;